import React from "react";
import { PostTemplate } from "./template/PostTemplate";
import { G_API } from "../constants/globalVar";

const AllCourses = ({ item }) => {
    const defaultImage = G_API+'uploads/ahnyar-logo.png';
    const data = {
        image: item?.feature_img?.src ?? defaultImage,
        title: item.title,
        description: item.description ?? '....',
        updated_at: item.updated_at,
        url: `/courses/${item.id}` ?? '#'
    };

    return (
        <PostTemplate props={data} />
    );
}

export default AllCourses;
